export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-23.dae2a93c.png";